import React from "react";

export const AccessDeniedPage = () => {
    return <>
        <h3 className="display-6 job-page-header" >Access Denied</h3>
        <p>You do not have permission to access the requested resource.</p>
        <p><a href="/">Return to Home</a></p>
    </>
}
